import { IIndexable } from "../interfaces/IIndexable";
import Dates from "./Dates";
import store from "../states/Store";
import Instrument from "./Instrument";
import Numbers from "./Numbers";
import Service from "./Service";

export default class Quote extends Instrument {
  public Value: number | string = '';
  public Yield: number | string = '';
  public Enabled: boolean = true;
  public Volatility: number = 0.7;

  public static serialize(quote: Quote): string {
    const valuation: string = Dates.ToAODate(store.MarketData.ValuationDate.getValue()).toString();
    const value: string = (quote.Type === 'FUT' ? quote.Yield : quote.Value).toString();
    const str = `${Instrument.serialize(quote)}@${valuation}:${value}`;
    return str;
  }

  public static deserialize(str: string): Quote {
    const params = str.split(':');
    let quote = new Quote();
    quote = Object.assign(quote, Instrument.deserialize(params[0]));
    if (params.length > 1 && Numbers.isNumber(params[1])) {
      quote.Value = Number(params[1]);
      if (quote.Type === 'FUT') Quote.setYield(quote, quote.Value);
    }
    return quote;
  }

  public static getProperty = (quote: Quote, property: string): number | string | boolean =>
    (quote as IIndexable<any>)[property];

  public static setProperty = (quote: Quote, property: string, value: number | string | boolean): Quote => {
    switch (property) {
      case "Enabled":
        if(quote.Enabled === value as boolean) return quote;
        quote.Enabled = value as boolean;
        const exclusion = store.Exclusion.SyntheticInstruments.getValue();
        const instrument = Instrument.serialize(quote);
        const excluded = exclusion.indexOf(instrument) > -1;
        if (quote.Enabled && excluded)
          store.Exclusion.SyntheticInstruments.next(exclusion.filter(item => item !== instrument));
        if (!quote.Enabled && !excluded) {
          exclusion.push(instrument);
          store.Exclusion.SyntheticInstruments.next(exclusion);
        }
        break;
      case "Value":
        if(quote.Value === value as number | string) return quote;
        quote.Value = value as number | string;
        if (quote.Type === 'FUT') 
          quote.Yield = Math.random();// await Quote.setYield(quote, value);
        break;
      case "Volatility":
        if(quote.Volatility === value as number) return quote;
        if (quote.Type === 'FUT' && !isNaN(Number(value))) {
          quote.Volatility = value as number;
          quote.Yield = Math.random(); // await Quote.setYield(quote, quote.Value);
        }
        break;
      default:
        if((quote as IIndexable<any>)[property] === value) return quote;
        (quote as IIndexable<any>)[property] = value
    }
    return quote;
  }

  public static setYield = async (quote: Quote, value: number | string | boolean): Promise<number | string | boolean> =>
    quote.Yield = isNaN(Number(value))
      ? ''
      : await Service.post('data','GetFutureConvexityAdjustment', JSON.stringify(
        {
          future: Instrument.serialize(quote),
          price: quote.Value,
          volatility: quote.Volatility
        }), false);
}
